import { tiendasApi } from '../api'

export const workshopsSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getPaginated: builder.mutation({
            query: ({ page = 1, limit = 15 }) => ({
                url: `web/workshops?page=${page}&limit=${limit}`,
                method: 'GET'
            })
        }),
        getById: builder.mutation({
            query: ({ id }) => ({
                url: `web/workshops/${id}`,
                method: 'GET'
            })
        }),
        getSignedUrl: builder.mutation({
            query: ({ id, body }) => ({
                url: `web/workshops/${id}/video`,
                method: 'POST',
                body
            })
        }),
    })
})

export const {
    useGetPaginatedMutation,
    useGetByIdMutation,
    useGetSignedUrlMutation,
} = workshopsSlice